import { SelfFixFeature } from './self-fix-feature.enum';

export type SelfFixFeatures = Partial<Record<SelfFixFeature, boolean>>;
